import React, { Component } from 'react';
import { required, SimpleForm, Button, ArrayField, Toolbar, SaveButton, Edit, Create, BooleanInput, Datagrid, TextField, TextInput, AutocompleteInput, ReferenceInput, BooleanField } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';

const BatchCreateToolbar = props => (
	<Toolbar {...props} >
		<SaveButton label="  Save Batch " redirect="edit" submitOnEnter={false} />
	</Toolbar>
);

const siteRenderer = (choice) => {
	if (!choice || !choice.name) return '';
	return `${choice.name}  (${choice.publisher_name}) (${choice.code})`;
};
export class PlacementBatchCreate extends Component {
	state = {
		publisherId: ''
	}
	constructor(prop) {
		super(prop);
	}
	handlePublisherInputChanged = (value) => {
		this.setState({ publisherId: value });
	}
	siteFormFilter = (searchText) => {
		if (this.state.publisherId) return { search_name: searchText, publisher_id: this.state.publisherId };
		else return { search_name: searchText };
	}
	render() {
	return (
	<Create title="Batch Placements" {...this.props}>
		<SimpleForm toolbar={<BatchCreateToolbar />} >
			<BooleanInput source="placements" label="Placements Batch?" defaultValue={true} style={{ display: 'none' }} />
			<h3 style={{width: '100%'}}>Select Publisher and Site</h3>
			<div style={{ width: '400px' }}>
			<ReferenceInput
				source="publisher_id"
				label="Publisher"
				reference="publishers"
				basePath="publishers"
				perPage={200}
				sort={{ field: 'name', order: 'ASC' }}
				onChange={this.handlePublisherInputChanged}
				filterToQuery={searchText => ({ search_name: searchText })}
				allowEmpty
				fullWidth>
				<AutocompleteInput label="Publishers" optionText="name" optionValue="code" />
			</ReferenceInput>
			<ReferenceInput
				source="site_id"
				label="Site"
				reference="sites"
				basePath="sites"
				perPage={200}
				sort={{ field: 'name', order: 'ASC' }}
				filterToQuery={searchText => this.siteFormFilter(searchText)}
				allowEmpty
				fullWidth>
				<AutocompleteInput label="Sites" optionText={siteRenderer} optionValue="code" style={{ width: '400px' }} />
			</ReferenceInput>
			</div>
			<div style={{ width: '100%' }}>
				<br /><h3>Batch Format For Placements:</h3>
		placement_name*,site_id(optional)
		</div>
			<TextInput multiline source="content" label="Sites or Placements Batch"
				initialValue=""
				fullWidth
			/>
		</SimpleForm>
	</Create>
)}
};

const EmptyToolbar = props => (
	<Toolbar {...props} >
		<Button href="/#/batchp/" label="Back to Batch processing" variant="contained" color="primary" startIcon={<EditIcon />} />
	</Toolbar>
);
export const PlacementBatchEdit = (props) => (
	<Edit title="Batch Results" {...props} >
		<SimpleForm toolbar={<EmptyToolbar />} >
			<BooleanField source="success" label="Success?" />
			<ArrayField source="messages" label="Messages" style={{ width: '100%' }} >
				<Datagrid>
					<TextField source="message" />
				</Datagrid>
			</ArrayField>
		</SimpleForm>
	</Edit>
);
